import { FormLayout } from "../../../form/formLayout/FormLayout"
import { Skeleton } from "../../../skeleton"

export const ListingDescriptionFormSkeleton = () => {
	return (
		<FormLayout $width="half">
			<Skeleton.Textarea withLabel withDescription />
		</FormLayout>
	)
}
